import React from 'react';

import { ThemeProvider } from 'styled-components';

import { Box } from '@waglabs/box-next';
import { theme } from '@waglabs/base-theme';
import { Typography } from '@waglabs/typography';
import { Button } from '@waglabs/button-next';

import { NavigationWrapper } from '../../../NavigationPage/NavigationWrapper';
import { Container } from '../../../../components/Container';

import { DATA_TEST_IDS } from '../../../../constants';

export type PasswordRecoverySuccessProps = {
  loginUrl: string;
};
export const PasswordRecoverySuccess = ({
  loginUrl,
}: PasswordRecoverySuccessProps) => {
  return (
    <NavigationWrapper
      title="Password Recovery"
    >
      <ThemeProvider
        theme={theme}
      >
        <Container
          my={5}
        >
          <Typography
            variant="h1"
            fontFamily="muliBold"
            textAlign="center"
            data-testId={DATA_TEST_IDS.ResetPassword.SuccessText}
          >
            Successfully Reset Password
          </Typography>
          <Box
            px={3}
            py={3}
            borderRadius="8px"
            textAlign="center"
          >
            <Button
              href={loginUrl}
              my={1}
            >
              Back to login
            </Button>
          </Box>
        </Container>
      </ThemeProvider>
    </NavigationWrapper>
  );
};
